export default __webpack_public_path__ + "static/media/haskey.cf5ece09.svg";